import { Component } from "react"

/* Link */
import { Link, NavLink } from "react-router-dom"

/* Redux */
import { connect } from "react-redux"

/* Constants */
import { menu } from "../constants"

/* Timezone Switcher */
import TimezoneSwitcher from "./TimezoneSwitcher"

/* Icons */
import { ChevronLeftIcon } from "./Icons"

/* Translate */
import { t } from "../translates/translate"

/* PitBoard — a row that opens another service instead of a page */
import { openPitBoard } from "./PitBoard"



/* Widget Menu */
class Menu extends Component {


    /* Draw Language Switcher */
    _languageSwitcher = () => {

        const { language, setLanguage, minimized } = this.props

        return (
            <div className="menu-lang-switcher">
                <div
                    onClick={() => setLanguage("ru")}
                    className={`menu-lang-item ${language === "ru" ? "active" : ""}`}
                >
                    {minimized ? "RU" : t("lang.ru")}
                </div>
                <div
                    onClick={() => setLanguage("en")}
                    className={`menu-lang-item ${language === "en" ? "active" : ""}`}
                >
                    {minimized ? "EN" : t("lang.en")}
                </div>
            </div>
        )
    }


    /* Draw Items — THE SHRUNK MENU KEEPS THE NAME IN A TOOLTIP */
    _items = () => {

        const { minimized, admin } = this.props

        return menu.getItems(admin).map((item, index) => {

            /* Draw Divider */
            if (item.name === "space") {
                return <div className="menu-space" key={`${index}`} />
            }

            /* Draw Action — PitBoard opens in a tab of its own */
            if (item.action === "pitboard") {
                return (
                    <div key={`${index}`} onClick={() => openPitBoard()} className="menu-item" title={minimized ? item.text : undefined}>
                        <span className="menu-item-bar" />
                        <div className="menu-image">{item.image}</div>
                        <span className="menu-item-text">{item.text}</span>
                    </div>
                )
            }

            return (
                <NavLink key={`${index}`} to={item.link} className="menu-item" title={minimized ? item.text : undefined}>
                    <span className="menu-item-bar" />
                    <div className="menu-image">{item.image}</div>
                    <span className="menu-item-text">{item.text}</span>
                </NavLink>
            )
        })
    }


    render = () => {

        const { minimized, toggle } = this.props

        return (
            <div className={`menu ${minimized ? "minimized" : ""}`}>

                <div className="menu-inner">

                    <Link to="/" className="menu-logo">
                        <span>
                            <img src="/images/logo.png" alt="Logo" />
                        </span>
                        <h1>Game Center</h1>
                    </Link>

                    <div className="menu-box">
                        {this._items()}
                    </div>

                    <div className="menu-foot">

                        {this._languageSwitcher()}

                        <TimezoneSwitcher minimized={minimized} />

                    </div>

                </div>

                <div onClick={() => toggle()} className={`menu-arrow ${minimized ? "active" : ""}`}>
                    <ChevronLeftIcon size={14} />
                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        admin: state.admin,
        language: state.language,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setLanguage: (lang) => dispatch({ type: "SET_LANGUAGE", payload: lang }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)
